var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-[#f0f]"},[_c('NavBar'),_c('Banner'),_c('VideoSection'),_c('Remembering'),_c('Slider'),_c('Condolences'),_c('Testimonial',{ref:"Testimonial"}),_c('QA'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }